import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

export default {
  data() {
    return {
      alertLeave: false,
    };
  },

  methods: {},

  beforeRouteLeave(to, from, next) {
    if (this.alertLeave) {
      swal
        .fire({
          title: this.$t("COMMON.DISCARD_CHANGES_AND_LEAVE_PAGE"),
          type: "question",
          buttonsStyling: false,
          showCancelButton: true,
          confirmButtonText: this.$t("COMMON.YES"),
          cancelButtonText: this.$t("COMMON.NO"),
          confirmButtonClass: "btn btn-primary",
          cancelButtonClass: "btn btn-warning",
        })
        .then((confirmation) => {
          if (confirmation.value === true) {
            next();
          } else {
            next(false);
          }
        });
    } else {
      next();
    }
  },
};
